/**
 * Returns x-esb-url header
 * Is the curren direction in the browser, is for new relic.
 */
function getESBUrlHeader() {
  const currentUrl = btoa(window.location.href);
  return {
    'x-esb-url': currentUrl,
  };
}

export default getESBUrlHeader;
